const unjson = (data: string) => JSON.parse(data)
const compileJson = (data?: Object) => btoa(JSON.stringify(data))
const uncompileJson = (data?: string) => data && unjson(atob(data))

export { unjson, compileJson, uncompileJson }
